import React from 'react'
import TextField from '../../../baseApp/shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';

const CompanySubForm = ({
    websiteLink,
    handleOnFieldBlur,
    viewMode,
    handleFieldChange,
}) => {
    return <div id="open-spaces-sub-form" className="field-row">
        <div className="row">
            <TextField
                value={websiteLink.value}
                error={websiteLink.error}
                label={I18n.t("subForms.field.websiteLink")}
                handleFieldChange={value => handleFieldChange("websiteLink", value)}
                themeName="form"
                disabled={viewMode}
                width={4}
            />
        </div>
    </div>
};

export default CompanySubForm;